import React from 'react';
import { HTMLMotionProps, motion } from 'motion/react';

export interface FadeInProps extends HTMLMotionProps<'div'> {
  delay?: number;
  duration?: number;
}

/**
 * A reusable fade-in animation component.
 * Fades in with a subtle scale effect on mount.
 *
 * @param delay - Delay before animation starts (in seconds)
 * @param duration - Animation duration (in seconds, default: 0.25)
 */
export const FadeIn = ({ delay = 0, duration = 0.25, children, ...props }: FadeInProps) => (
  <motion.div
    initial={{ opacity: 0, scale: 0.95, width: '100%' }}
    animate={{ opacity: 1, scale: 1 }}
    exit={{ opacity: 0, scale: 0.95 }}
    transition={{
      duration,
      ease: 'easeInOut',
      delay,
    }}
    {...props}
  >
    {children}
  </motion.div>
);
